import { TextField, TextFieldProps } from "@mui/material";

const defaultStyles = {
  "& .MuiOutlinedInput-root:hover fieldset": {
    borderColor: "rgba(0, 0, 0, 0.23)",
  },
  "& .MuiOutlinedInput-root.Mui-focused fieldset": {
    borderColor: "rgba(0, 0, 0, 0.23)",
    borderWidth: 1,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "rgba(0, 0, 0, 0.6)",
  },
  "& .MuiOutlinedInput-input:focus": {
    color: "inherit",
  },
  "& .MuiInputBase-inputMultiline": {
    overflow: "hidden",
  },
};

export const readOnlyTextFieldStyles = {
  root: {
    default: defaultStyles,
    clickable: {
      ...defaultStyles,
      ".MuiOutlinedInput-input": {
        cursor: "pointer",
      },
    },
  },
};

const ReadOnlyTextField: React.FC<TextFieldProps> = (props) => {
  return (
    <TextField
      className={"readOnlyTextField"}
      {...props}
      InputProps={{
        readOnly: true,
        ...props.InputProps,
      }}
      sx={readOnlyTextFieldStyles.root.default}
    />
  );
};

export default ReadOnlyTextField;
